"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeHistoryState = initializeHistoryState;
function initializeHistoryState() {
  if (typeof window === 'undefined') {
    return;
  }
  function currentUrl() {
    return window.location.pathname + window.location.search + window.location.hash;
  }
  function dispatchEvent(name, force) {
    const {
      state
    } = window.history;
    const url = currentUrl();
    if (!force && url === lastUrl) {
      return;
    }
    window.dispatchEvent(new CustomEvent(`history:${name}`, {
      detail: {
        state,
        url,
        lastUrl
      }
    }));
  }
  let lastUrl = document.referrer || currentUrl();
  const script = document.createElement('script');
  script.defer = true;
  script.async = false;
  script.src = 'data:text/plain,';
  script.addEventListener('load', () => {
    document.body.removeChild(script);
    dispatchEvent('load', true);
    lastUrl = currentUrl();
  });
  document.addEventListener('DOMContentLoaded', () => {
    document.body.appendChild(script);
  });
  const _pushState = window.history.pushState;
  window.history.pushState = function pushState(state, title, url) {
    _pushState.call(window.history, ...arguments);
    dispatchEvent('push');
    dispatchEvent('change');
    lastUrl = currentUrl();
  };
  const _replaceState = window.history.replaceState;
  window.history.replaceState = function replaceState(state, title, url) {
    _replaceState.call(window.history, ...arguments);
    dispatchEvent('replace');
    dispatchEvent('change');
    lastUrl = currentUrl();
  };
  window.addEventListener('popstate', () => {
    dispatchEvent('pop');
    dispatchEvent('change');
    lastUrl = currentUrl();
  });
}